export const translationsObject = {
  Home: { fr: "Accueil" },
  Export: { fr: "Exporter" },
  Add: { fr: "Ajouter" },
  Campaign: { fr: "Campagne" },
  Campaigns: { fr: "Campagnes" },
  Results: { fr: "Résultats" },
  "General data": { fr: "Données générales" },
  "Reports": {fr:"Rapports"},
  "Results (admin)": { fr: "Résultats (admin)" },
  Users: { fr: "Utilisateurs" },
  User: { fr: "Utilisateur" },
  "New User": { fr: "Utilisateur" },
  Save: { fr: "Sauvegarder" },
  Members: { fr: "Adhérents" },
  Member: { fr: "Adhérent" },
  Enter: { fr: "Entrer" },
  New: { fr: "Nouvel" },
  "Close":{fr:"Fermer"},
  "Member Details": { fr: "Adhérent detail" },
  "GTA Code": { fr: "Code GTA" },
  "Member Name": { fr: "Nom adherent" },
  "Column Type": { fr: "Type de colonnes" },
  "List of Members": { fr: "Liste d'adhérents" },
  "Column type": { fr: "Type de colonnes" },
  Name: { fr: "Prénom" },
  Role: { fr: "Rôle" },
  Password: { fr: "Mot de passe" },
  "Last Name": { fr: "Nom" },
  "New user": { fr: "Nouvel utilisateur" },
  "New user account": { fr: "Nouveau compte utilisateur" },
  "Campaign identification": { fr: "Identification de la campagne" },
  Dates: { fr: "Dates de la campagne" },
  Date: { fr: "Date d'ajout" },
  "Start Date": { fr: "Date de début" },
  "Close Date": { fr: "Date de cloture" },
  Complete: { fr: "Saisir" },
  "Closed on": { fr: "Clôturée le" },
  Closed: { fr: "Clôturée" },
  "Started on": { fr: "Ouverte le" },
  Create: { fr: "Créer " },
  "New Campaign": { fr: "Nouvelle Campagne" },
  "Upload New File": { fr: "Ajouter un nouveau fichier" },
  "In Progress": { fr: "en cours" },
  "Number of files": { fr: "Nombre de fichiers" },
  "Campaign ID": { fr: "Campagne ID" },
  Select: { fr: "Sélectionner" },
  "Number of lines": { fr: "Nombre de lignes" },
  "Unprocessed file": { fr: "Fichier brut" },
  "Files List": { fr: "Liste des fichiers" },
  "Download": { fr: "Télécharger"},
  Data: { fr: "Les données" },
  "Data Details": { fr: "Visualiser les données" },
  Verify: { fr: "Vérifier" },
  "UW Year": { fr: "Exercice" },
  "Adding date": { fr: "Date d’ajout" },
  "Annual premium": { fr: "Prime annuelle" },
  "Inception date": { fr: "Date début" },
  "Resignation date": { fr: "Date fin" },
  "Cover time": { fr: "Durée" },
  "Coinsurance Share": { fr: "Part de coassurance" },
  "Line of business": { fr: "Catégorie" },
  "Risk reference": { fr: "Numero risque" },
  Address: { fr: "Adresse du risque assuré" },
  "INSEE Code of risk": { fr: "Code INSEE du risque" },
  "Postal Code of risk": { fr: "Code postal du risque" },
  "City of risk": { fr: "Commune du risque" },
  Latitude: { fr: "Latitude" },
  Longitude: { fr: "Longitude" },
  "Building Type": { fr: "Type Batiment" },
  "Statue of occupancy": { fr: "Qualité juridique de l’assuré" },
  "Number of main rooms in risks (residential)": { fr: "Nb pièces" },
  "Area (commercial risks)": { fr: "Surface" },
  "Activity (if commercial risks)": { fr: "Type d'activité (si professionnelle)" },
  "Sums Insured (Building)": { fr: "Sommes assurées (Batiment)" },
  "Sums Insured (Content)": { fr: "Sommes assurées (Contenu)" },
  "Sums Insured (BI)": { fr: "Sommes assurées (PE)" },
  "Sums Insured (Total)": { fr: "Sommes assurées (Total)" },
  "Sum insured": {fr: "Somme assurée"},
  CCL: { fr: "LCI" },
  "Fire/Terror deductible": { fr: "Franchise incendie/Attentat" },
  Comments: { fr: "Commentaires" },
  File: { fr: "Fichier" },
  "File type": { fr: "Type de fichier" },
  "Data analysis": { fr: "Analyse des données" },
  Result: { fr: "Résultat" },
  "Data Validation": { fr: "Validation des données du fichier des risques à l'adresse" },
  "Upload File": { fr: "Charger une nouvelle déclaration" },
  "Upload a file on the plateforme": { fr: "Charger un fichier sur la plateforme" },
  "Calculate": { fr: "Calculer" },
  indicator: { fr: "Indicateur" },
  "Select the sheet name": { fr: "Sélectionner la feuille" },
  "The number of lines in the header": {
    fr: "Le nombre de lignes d'en-tête de cette feuille",
  },
  Analysis: { fr: "Analyse" },
  "This file already exists": { fr: "Le fichier existe déjà" },
  "Gareat Rates": { fr: "Taux Gareat" },
  "Gareat Rates in %": { fr: "Taux Gareat en %" },
  "Welcome to your SMR platform": { fr: "Bienvenue sur votre plateforme RPM" },
  "Welcome": { fr: "Bienvenue" },
  "Branch of insurance": { fr: "Branches d'assurance" },
  "Branch": { fr: "Branche" },
  "Alias": {fr: "Alias"},
  "New branch": { fr: "Nouvelle branche" },
  "File Type": { fr: "Type de fichier" },
  "File Type EN": { fr: "Type de fichier EN" },
  "File Type FR": { fr: "Type de fichier FR" },
  "Files": { fr: "Fichiers" },
  "New file type": { fr: "Nouveau type de fichier" },
  "Files type": { fr: "Type de fichiers" },
  "Language": {fr: "Langue"},
  "Number of received declarations (risk files at the address)": { fr: "Nombre de déclarations reçues (fichiers de risques à l'adresse)" },
  "Number of rows": { fr: "Nombre de lignes" },
  "Number of Appendix I received": { fr: "Nombre d'Annexes I reçues" },
  "Number of Appendix II received": { fr: "Nombre d'Annexes II reçues" },
  "Number of Appendix III received": { fr: "Nombre d'Annexes III reçues" },
  "Number of FR 13-03 files received": { fr: "Nombre de fichiers FR 13-03 reçues" },
  "Insurance branch codification": { fr: "Codification des branches d'assurance" },
  "Identified codifications in the declaration": { fr: "Codifications identifiées dans la déclaration" },
  "Corresponding business sectors by respective branch for Gareat": { fr: "Secteurs d'activité correspondant par Branche correspondante pour Gareat" },
  "Accounting Code": {fr: "Code Comptable"},
  "Declaring Members": {fr: "Adhérents déclarants"},
  "Line of Business": {fr: "Catégorie de Risques"},
  "MOTOR (exc liability)": {fr: "DOMMAGE AUTO"},
  "PERSONAL LINES": {fr: "PARTICULIERS"},
  "PROFESSIONAL PROPERTY DAMAGES including :": {fr: "DOMMAGES AUX BIENS PROFESSIONNELS dont :"},
  "PROFESSIONAL  (Large Risks excluded)": {fr: "PROFESSIONNELS (Hors Primes Grands Risques)"},
  "AGRICULTURAL (exc hail)": {fr: "AGRICOLES (hors grêle)"},
  "Optional alternative": {fr: "Option facultative"},
  "OTHER PROPERTY DAMAGES": {fr: "AUTRES DOMMAGES"},
  "AVIATION HULL < 1 million €": {fr: "CORPS AERONEF TOURISME (< 1M€)"},
  "NAV. HULL.PL < 1 million €": {fr: "CORPS NAVIGATION PLAISANCE (< 1M€)"},
  "TOTAL": {fr: "TOTAL"},
  "Number of polices": {fr: "Nombre de polices"},
  "Written premiums": {fr: "Primes émises"},
  "Written premium": {fr: "Prime émise"},
  "Gareat Premiums": {fr: "Primes Gareat"},
  "Campaign Follow Up": {fr: "Suivi de la campagne"},
  "CCR Group": {fr: "Groupe CCR"},
  "Declarer": {fr: "Déclarant"},
  "File loading": {fr: "Chargement des fichiers"},
  "State": {fr: "État"},
  "Monitoring": {fr: "Suivi"},
  "Injected on": {fr: "Injecté le"},
  "by": {fr: "par"},
  "Status": {fr: "Statut"},
  "Risk at the address": {fr: "Risque à l'adresse"},
  "Risk at the address file": {fr: "Fichier de risque à l'adresse"},
  "Other file": {fr: "Autres fichiers"},
  "Codifications of insurance branches": {fr: "Codifications de branches d'assurance"},
  "Data quality": {fr: "Qualité des données"},
  "File upload": {fr: "Chargement des fichiers"},
  "Risks at the address file": {fr: "Fichier des risques à l'adresse"},
  "Appendix I": {fr: "Annexe I"},
  "Appendix II": {fr: "Annexe II"},
  "Appendix III": {fr: "Annexe III"},
  "Template to download": {fr: "Télécharger le modèle à compléter"},
  "You need to specify valid user for this member": {fr: "Vous devez spécifier un utilisateur valide pour cet adhérent"},
  "Lines of business mapping": {fr: "Codification des branches d'assurance"},
  "Departments detail": {fr: "Par département"},
  "Department": {fr: "Département"},
  "Police number": {fr: "Nb polices"},
  "Insured sum": {fr: "Sommes assurées"},
  "Issued prime": {fr: "Primes émises"},
  "Year Y+1": {fr: "Exercice N+1"},
  "Categories de Risques": {fr: "Catégories de risques"},
  "Premiums": {fr: "Primes"},
  "Gareat rates": {fr: "Taux Gareat"},
  "Gareat premiums": {fr: "Primes Gareat"},
  "PROFESSIONAL (Large Risks excluded)": {fr: "PROFESSIONNELS (Hors Primes Grands Risques)"},
  "NAV. HULL PL < 1 milliom": {fr: "CORPS NAVIGATION PLAISANCE (< 1M€)"},
  "Appendix I and Appendix II": {fr: "Annexe I et Annexe II"},
  "Appendix I and Appendix III": {fr: "Annexe I et Annexe III"},
  "Appendix evolution": {fr: "Evolution d'annexes"},
  "Number of polices (Appendix I)": {fr: "Nombre de polices (Annexe I)"},
  "Premiums (Appendix I)": {fr: "Primes (Annexe I)"},
  "Number of polices (Appendix II)": {fr: "Nombre de polices (Annexe II)"},
  "Premiums (Appendix II)": {fr: "Primes (Annexe II)"},
  "Number of polices (Appendix III)": {fr: "Nombre de polices (Annexe III)"},
  "Estimated premiums (Appendix III)": {fr: "Primes estimées (Annexe III)"},
  "Number of polices (risk)": {fr: "Nombre de polices (risques)"},
  "Premiums (risk)": {fr: "Primes (risques)"},
  "Closure Date": {fr: "Date de clôture"},
  "Lines": {fr: "Lignes"},
  "file_type_en": {fr: "file_type_fr"},
  "The user cannot be deleted because it is the contact of a member.": {fr: "L'utilisateur ne peut pas être supprimé car il est le contact d'un adhérent."},
  "The closure date should be greater than the start date": {fr: "La date de clôture doit être supérieure à la date de début."},
  "Please fill in all fields before saving":{fr:"Veuillez remplir tous les champs avant de sauvegarder"},
  "Estimated premiums": {fr: "Primes estimées"},
  "Updated file": {fr: "Fichier modifié"},
  "File updated manually": {fr: "Fichier modifié suite à une saisie manuelle"},
  "File was uploaded successfully.": {fr: "Le fichier a été chargé avec succès."},
  "Error occurred during upload.": {fr: "Une erreur s'est produite lors du téléchargement."},
  "Invalid Lines": {fr: "Lignes invalides"},
  "All Lines": {fr: "Toutes les lignes"},
  "Nb of polices": {fr: "Nombre de polices"},
  "Revised EXERCISE N-1": {fr: "Révisé EXERCICE N-1"},
  "Table have to contain only numeric values": {fr: "Le tableau ne doit contenir que des valeurs numériques"},
  "There is no field completed in the file, please fill out your Excel file before uploading it on the platform.": {fr: "Aucun champ n’est renseigné dans le fichier, veuillez saisir les données dans le fichier avant le chargement sur la plateforme."},
  "A non-numeric character has been entered in the file fields, file upload blocked.": {fr: "Un caractère non numérique a été renseigné dans les champs du fichier, chargement du fichier bloqué."},
  "The amounts are in euros": {fr: "Les montants sont en euros"},
  "You are about to modify the list of campaign members.": {fr: "Vous êtes sur le point de modifier la liste des adhérents de la campagne"},
  "You are about to modify the list of cover year members.": {fr: "Vous allez modifier la liste des adhérents déclarants de l’année sélectionnée"},
  "Platform_Tutorial_SMR_Gareat_ENG_User.pdf": {fr: "Tutoriel_plateforme_RPM_Gareat_FR_Utilisateur.pdf"},
  "The format is not valid": {fr: "Le format du fichier n'est pas correct"},
  "Task successfully completed": {fr: "Tâche terminée avec succès"},
  "File contains incorrectly named sheet": {fr: "Le fichier contient une feuille mal nommée"},
  "Uploading file on the server": {fr: "Téléchargement du fichier sur le serveur"},
  "Creating campaign file": {fr: "Création du dossier de campagne"},
  "Created campaign file": {fr: "Fichier de campagne créé"},
  "Successfully uploaded": {fr: "Téléversé avec succès"},
  "Your zip file should content only one file and no folders": {fr: "Votre fichier zip ne doit contenir qu’un seul fichier et pas de dossiers."},
  "In case you upload the data in a zip file, notice that only zip of one unique file and no folder are authorized": {fr: "Dans le cas où vous téléchargez les données dans un fichier zip, notez que seul le zip d'un fichier unique et aucun dossier n'est autorisé."},
  "Difference police number": { fr: "Ecart Nombre de Polices" },
  "Difference premiums": { fr: "Ecart Primes Emises" },
  "Insured Sums (Risk)": { fr: "Sommes assurées (Risk File)" },
  "Insured Sums (Annexe II)": { fr: "Sommes assurées (Annexe II)" },
  "Difference insured sums": { fr: "Ecart Sommes Assurées" },
  "Historical": { fr: "Historique" },
  "Control report": { fr: "Rapport de contrôle (compilation Annexe II)" },
  "Threshold history": { fr: "Historique seuil" },
  "Gareat prime historical": { fr: "Historique primes Gareat" },
  "Reports": { fr: "Rapports" },
  "Collected premiums": { fr: "Encaissement" },
  "Estimated premiums ": { fr: "Estimations " },
  "Statistics report": { fr: "Rapport de statistiques (compilation Annexe I et Annexe III)" },
  "Edited by": { fr: "Modifié par" },
  "Update Date": { fr: "Date de modification" },
  "Injected by": { fr: "Injecté par" },
  "Create Date": { fr: "Date de création" },
  "The campaign configuration was": {fr: "La configuration de la campagne a été"},
  "created by": {fr: "créée par"},
  "updated by": {fr: "mise à jour par"},
  "on": {fr: "le"},
  "Prior to being able to view risk file analyses, it is necessary to first assign insurance branches": {fr: "Avant de pouvoir visualiser les analyses des fichiers de risques, il est nécessaire de procéder préalablement à l'affectation des branches d'assurance"},
  "File name": {fr: "Nom de fichier"},
  "The report is being generated": {fr: "Le rapport est en cours de génération"},
  "Edit": { fr: "Editer"},
  "Injecting members": { fr: "Injection d'adhérents" },
  "Rates injected": { fr: "Taux injectés" },
  "Report creation": { fr: "Création du rapport" },
  "Report created": { fr: "Création du rapport finalisé" },
  "Close": { fr: "Fermer" },
  "Downloading file": { fr: "Téléchargement du fichier"},
  "Modified on": { fr: "Modifié le" },
  "A member with the same GTA code and the same accounting code already exists": { fr: "Un adhérent avec le même code GTA et le même code comptable existe déjà" },
  "Some errors were encountered while uploading the file. Please verify the format or contact an administrator": { fr: "Des erreurs ont été rencontrées lors du téléchargement du fichier. Veuillez vérifier le format ou contacter un administrateur." },
  CoverYear: {fr: "Année de couverture"},
  CoverYears:  {fr: "Années de couverture"},
  "Cover Year": {fr: "Année de couverture"},
  "Cover Years":  {fr: "Années de couverture"},
  "New Cover Year": { fr: "Nouvelle Année de couverture"},
  "GAREAT rates": {fr: "Taux GAREAT"},
  "GAREAT Rates" : {fr: "Taux GAREAT"},
  "Year identification": {fr: "Identification de l'année"},
  "The cover year configuration was": {fr: "La configuration de l'année de couverture a été"},
  "Upload": {fr: "Charger"},
  "Saved CoverYear Details": {fr:"Taux sauvegardés"},
  "This cover year is already created, you can change it in the GAREAT Rates section": {fr: "Cette année de couverture a déjà été créée, vous pouvez la modifier dans la partie Taux Gareat"},
  "CCR Rates": {fr:"Taux CCR"},
  "CCR Threshold Rates": {fr:"Taux Seuil CCR"},
  "Not filled": {fr:"Non Complété"},
  "Year": {fr:"Année"},
  "CCR Group n":{fr:"Groupe CCR n"},
  "Select campaign year": {fr:"Sélectionnez l'année de la campagne"},
  "Upload campaign members file": {fr:"Charger le fichier des membres de la campagne"},
  "Only xlsx files allowed": {fr:"Seuls les fichiers XLSX autorisés"},
  "Saved Campaign Members": {fr: "La liste des adhérents de la campagne a été sauvegardée"},
  "Something went wrong": {fr:"Une erreur est survenue"},
  "Saved Campaign Details": {fr:"Détails de la campagne sauvegardés"},
  "click or drop files here": {fr:"Cliquez ou faites glisser vos fichiers ici"},
  "Dismiss": {fr:"Fermer"},
  'Upload running...': {fr:"Téléchargement en cours..."},
  "Import data for": {fr:"Importer des données pour"},
  "Do not leave this page": {fr:"N'abandonnez pas cette page"},
  "Please wait until the upload is completed": {fr:"Veuillez patienter jusqu'à la fin de l'upload"},
  "Injected members": {fr:"Adherents sont injectés"},
  "Showing {from} to {to} of {count} rows|Showing all {count} rows|" : {fr: "Affichage de {from} vers {to} de {count} lignes|Affiche {count} lignes|"},
  'First': {fr: "Premier"},
  'Last': {fr: "Dernier"},
  'Filter:': {fr: "Filtre:"},
  'Search query': {fr: "Recherche de données:"},
  'Records:': {fr: "Enregistrements:"},
  'Page:': {fr: "Page:"},
  'No matching records': {fr: "Aucun enregistrement correspondant"},
  'Please select at least one filter to fetch results': {fr: "Veuillez sélectionner au moins un filtre pour récupérer les résultats"},
  'Filter by {column}': {fr: "Filtrer par {column}"},
  'Loading...': {fr: "Chargement..."},
  'Select {column}': {fr: "Sélectionnez {column}"},
  'Columns': {fr: "Colonnes"},
  'Show|results per page': {fr: "Afficher|résultats par page"},
  'Unselect all': {fr: "Tout désélectionner"},
  'First level': {fr: "Premier niveau"},
  'Reset columns to default': {fr: "Réinitialiser les colonnes par défaut"},
  'Cover Year CCR': {fr: "Taux CCR"},
  "Cover Year CCR Threshold": {fr: "Taux Seuil CCR"},
  'Select cover year': {fr:"Sélectionner l’année"},
  "Login failed": {fr:"Echec de connexion"},
  "Please fill all required data": {
    "fr": "Veuillez remplir tous les champs obligatoires."
  },
  "Failed to create campaign": {
    "fr": "Échec de la création de la campagne"
  },
  "Failed to create cover year": {
    "fr": "Échec de la création de l'année de couverture"
  },
  "Inputed rates must be positive": {
    "fr": "Les taux doivent être positifs"
  },
  "Data saved successfully": {fr:"Données sauvegardées"},
  'Successfuly saved Appendix I data': {fr:"Données de l'Annexe I sauvegardées"},
  'Successfuly saved Appendix II data': {fr:"Données de l'Annexe II sauvegardées"},
  'Successfuly saved Appendix III data': {fr:"Données de l'Annexe III sauvegardées"},
  "No Branch data. Please create Branch instance before creating new Campaign": {fr:"Aucune donnée de branche. Veuillez créer une instance de branche avant de créer une nouvelle campagne."},
  "No Branch data. Please create Branch instance before creating new Cover Year": {
    "fr": "Aucune donnée de branche. Veuillez créer une instance de branche avant de créer une nouvelle année de couverture"
  },
  "Successfully saved Business Mappings": {
    "fr": "Codification des branches sauvegardées"
  },
  "Successfully saved Appendix I data": {
    "fr": "Données de l'Annexe I sauvegardées"
  },
  "Member created successfully": {
    "fr": "Membre créé avec succès"
  },
  "Member saved successfully": {
    "fr": "Membre enregistré avec succès"
  },
  "Password change requested. Please check your email.": {
    "fr": "Demande de changement de mot de passe. Veuillez vérifier votre boîte e-mail."
  },
  "Passwords are not the same": {
    "fr": "Les mots de passe ne sont pas les mêmes"
  },
  "Your password has been changed. You can now login.": {
    "fr": "Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter."
  },
  "User created successfully": {
    "fr": "Utilisateur créé avec succès"
  },
  "User saved successfully": {
    "fr": "Utilisateur enregistré avec succès"
  },
  "Confirm": {
    "fr": "Confirmer"
  },
  "Saved Cover Year Members": {
    "fr": "Adhérents sauvegardés"
  },
  "Risk File I and Appendix II": {
    "fr": "Fichier des risques à l’adresse et Annexe II"
  }
}
